<!--新增/编辑节点-->
<template>
  <div class="recipient-add-wrap">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/companyRecipientManange' }"
        >节点管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>添加节点</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="recipient-add-con">
      <el-form :inline="true" label-width="120px">
        <!-- 收单点顶部文案 -->
        <div>
          <h3>收单点</h3>
          <div style="color: #666666ff; font-size: 14px">
            不同收单点可签收不同的业务，方便企业签收管理。收单规则可以根据企业的结算方式来设置
          </div>
        </div>
        <!-- 收单点 -->
        <div class="recipient-card-style mt-10">
          <el-form-item label-width="140px" label="节点名称" id="auto-0">
            <el-input
              style="width: 435px"
              v-model.trim="siteName"
              :maxlength="20"
              placeholder="示例：华西煤矿园"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 收单员 -->
        <div class="recipient-card-style mt-10">
          <div>
            <el-form ref="formRecopient" :inline="true" id="auto-6">
              <div v-for="(item, index) in formRecopient" :key="index">
                <el-form-item label-width="140px" label="收单员">
                  <el-input
                    style="width: 175px"
                    v-model.trim="item.name"
                    :maxlength="10"
                    placeholder="请输入收单员"
                    @input="updateSelectKeys(index)"
                  >
                    <template #suffix>
                      <div
                        v-if="index === 0"
                        @click="handleIconClick"
                        class="suffix-style"
                      >
                        <img
                          width="10"
                          height="6"
                          src="../../assets/img/setting/icon-arrow-down.png"
                          alt=""
                        />
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item class="ml-20" label="手机号">
                  <el-input
                    style="width: 175px"
                    v-model.trim="item.phone"
                    placeholder="请输入手机号"
                    @input="updateSelectKeys(index)"
                  >
                    <template #suffix>
                      <div
                        v-if="index === 0"
                        @click="handleIconClick"
                        class="suffix-style"
                      >
                        <img
                          width="10"
                          height="6"
                          src="../../assets/img/setting/icon-arrow-down.png"
                          alt=""
                        />
                      </div>
                    </template>
                  </el-input>
                </el-form-item>

                <div class="phone-right-style">
                  <el-checkbox
                    label=""
                    v-model="item.onState"
                    :true-label="1"
                    :false-label="0"
                    >收单点统计权限</el-checkbox
                  >
                  <img
                    style="margin-left: 5px; margin-top: -3px"
                    @click="stateTip = true"
                    width="16"
                    height="16"
                    src="../../assets/img/setting/icon-explain.png"
                    alt=""
                  />
                </div>

                <!-- <el-button
                  class="recipient-add-search"
                  v-if="index === 0"
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="handleIconClick"
                ></el-button> -->
                <el-button
                  class="recipient-add-del ml-10"
                  v-if="index !== 0"
                  size="small"
                  @click="del('formRecopient', index)"
                  >删除</el-button
                >
              </div>
            </el-form>
          </div>
          <div class="recipient-add-button-style" @click="addRecopient">
            <img src="../../assets/img/setting/icon-add.png" alt="" />
            <span>新增</span>
          </div>
        </div>
        <!-- 收单规则 -->
        <div class="recipient-card-style mt-10">
          <div>
            <el-form ref="formReceiveRule" label-width="140px" :inline="true" id="auto-8">
              <div v-for="(item, index) in formReceiveRule" :key="index">
                <el-form-item label="收单规则">
                  <div class="receiver-rule-style">
                    <div>
                      <el-input
                        style="width: 175px"
                        v-model="item.ruleName"
                        @focus="showDialog(index)"
                        placeholder="请选择"
                      ></el-input>
                      <el-button
                        class="ml-20"
                        v-if="index !== 0"
                        type="danger"
                        size="small"
                        @click="del('formReceiveRule', index)"
                        >删除</el-button
                      >
                    </div>
                    <p class="dec" v-if="item.constParams">
                      收单明细：{{ item.constParams | filterConstParams }}
                    </p>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div @click="addReceiveRule" class="recipient-add-button-style">
            <img src="../../assets/img/setting/icon-add.png" alt="" />
            <span>新增</span>
          </div>
        </div>
        <!-- 关联地址 签收差值提醒 -->
        <div class="recipient-card-style mt-10">
          <el-form-item label-width="140px" label="关联地址" id="auto-3">
            <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
              <el-input
                style="width: 435px"
                v-model="siteAddress"
                @click.native="handleSearchAddress"
                :readonly="true"
                placeholder="请选择地址"
              >
                <i
                  v-if="inputIcon == 'close'"
                  @click="handleClearAddress"
                  slot="suffix"
                  class="el-input__icon el-icon-close pointer"
                ></i>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label-width="140px" id="auto-1">
            <label class="label-custom" slot="label"
              >签收差值提醒
              <img
                @click="effectiveTonErrorMsg = true"
                width="16"
                height="16"
                src="../../assets/img/setting/icon-explain.png"
                alt=""
              />
            </label>
            <el-input
              class="input-custom-short"
              v-model.trim="effectiveTonError"
              :maxlength="10"
              placeholder="请输入"
            ></el-input>
            <el-dialog
              :visible.sync="effectiveTonErrorMsg"
              title="提示"
              custom-class="tip-dialog"
            >
              <p>收单时如实发、实收数量差值超过预设值，则签收时会有强制提醒</p>
              <div slot="footer" class="text-c">
                <el-button type="primary" @click="effectiveTonErrorMsg = false"
                  >我知道了</el-button
                >
              </div>
            </el-dialog>
          </el-form-item>
          <el-form-item
            label-width="140px"
            v-if="grossWeightLimitStatus == 1"
            id="auto-2"
          >
            <label slot="label">签收毛重最大值(吨)</label>
            <el-input
              class="input-custom-short"
              v-model.trim="grossWeightLimit"
              :maxlength="7"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <div v-if="siteRuleParams.length > 0" id="auto-4">
            <el-form-item
              v-for="(item, idx) in siteRuleParams"
              :key="idx"
              :label="item.ruleName"
              label-width="140px"
            >
              <el-switch
                v-model="item.status"
                class="mr-20 ml-10"
                :active-value="1"
                @change="handleSwitchchange(item)"
                :inactive-value="0"
                :disabled="
                  switchSelected.status && item.ruleCode !== switchSelected.ruleCode
                "
              >
              </el-switch>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="mt-30">
        <el-button
          v-if="siteCode"
          class="recipient-bottom-button"
          type="primary"
          @click="saveAll"
          id="auto-9"
          >保存</el-button
        >
        <el-button
          v-else
          class="recipient-bottom-button"
          type="primary"
          @click="saveAll"
          id="auto-9"
          >新增</el-button
        >
        <el-button
          class="recipient-bottom-button recipient-bottom-button-back"
          @click="saveOff"
          id="auto-10"
          >返回</el-button
        >
      </div>
    </div>
    <!--选择收单员-->
    <el-dialog title="选择收单员" :visible.sync="dialogRecopientVisible">
      <el-table
        height="500"
        ref="multipleTable"
        border
        :data="addressList"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          :selectable="isSelect"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column prop="contactsName" label="收单员">
          <template v-slot="scope">
            <div>{{ scope.row.contactsName }}</div>
            <div
              v-if="scope.row.receivedSiteRsp != null"
              style="font-size: 12px; color: #aaaaaaff"
            >
              已配置{{ scope.row.receivedSiteRsp.signSiteName }}节点
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contactsTel" label="手机号"></el-table-column>
      </el-table>
      <div class="mt-20 ml-50 pl-20">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!--选择常用地址-->
    <el-dialog title="选择地址" :visible.sync="dialogSiteSelectVisible">
      <el-table height="500" :data="addressList" border>
        <el-table-column prop="addressName" label="常用地址名称"></el-table-column>
        <el-table-column prop="addressDetail" label="详细地址"></el-table-column>
        <el-table-column label="联系人">
          <template v-slot="scope"
            >{{ scope.row.contactsName }} {{ scope.row.contactsTel }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <el-button
              type="primary"
              class="font-size12"
              @click="handleUseAddress(scope.row)"
              >使用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="stateTip" title="收单点统计权限" custom-class="tip-dialog">
      <p>打开开关后，收单员可以通过收单员端的统计模块，查询及导出该收单点的所有运单</p>
      <div slot="footer" class="text-c">
        <el-button type="primary" @click="stateTip = false">我知道了</el-button>
      </div>
    </el-dialog>
    <ReceiveRuleAlert @selectRules="selectRules" ref="receiveRuleRef"></ReceiveRuleAlert>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:10
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from "@/api/common";
import axios from "@/api/axiosNew";
import api from "@/api/base.new.api";
import { isNumber, isRangeNumber, isPhone } from "@fe/validator";
import ReceiveRuleAlert from "./components/ReceiveRuleAlert.vue";
export default {
  components: {
    ReceiveRuleAlert,
  },
  data() {
    return {
      ruleSelectIndex: -1,
      inputIcon: "",
      siteName: "", // 节点名称
      siteAddress: "", // 节点地址
      siteCode: "",
      latitude: 0,
      longitude: 0,
      relAddressName: "",
      receiveRuleAllList: [], // 所有收单规则list
      addressList: [],
      formRecopient: [
        // 待添加收单员list
        {
          name: "",
          phone: "",
          onState: 0,
        },
      ],
      formRecopientSubmit: [], // 最终提交收单员list
      formReceiveRule: [
        // 待添加收单规则list
        {
          ruleCode: "",
          constParams: null,
          ruleName: "",
        },
      ],
      formReceiveRuleSubmit: [], // 最终提交收单规则list
      multipleSelection: [], // 表格选中收单员list
      dialogRecopientVisible: false, // 选择收单员弹层是否显示标志
      effectiveTonError: 200, // 签收差值
      effectiveTonErrorMsg: false,
      dialogSiteSelectVisible: false,
      siteRuleParams: [], // 涨吨抹规则配置
      switchSelected: {
        ruleCode: "",
        status: false,
      },
      grossWeightLimit: "", // 毛重上限
      grossWeightLimitStatus: 0, // 毛重上限配置 1:开启0:关闭
      stateTip: false,
    };
  },
  created() {
    this.queryRuleRmexcess();
    this.siteCode = this.$route.query.siteCode;
    if (this.siteCode) {
      this.fetchData();
    }
  },
  methods: {
    updateSelectKeys(index) {
      var resultList = this.addressList.filter(
        (el) =>
          el.contactsName === this.formRecopient[index].name &&
          el.contactsTel === this.formRecopient[index].phone
      );
      if (resultList.length == 0) {
        delete this.formRecopient[index]["source"];
      } else {
        this.formRecopient[index].source = "select";
      }
    },
    selectRules(arg) {
      if (this.formReceiveRule.map((el) => el.ruleCode).includes(arg.ruleCode)) {
        this.$message.error("该收单规则已经选择");
        return;
      }
      this.formReceiveRule[this.ruleSelectIndex].ruleCode = arg.ruleCode;
      this.formReceiveRule[this.ruleSelectIndex].constParams = arg.constParams;
      this.formReceiveRule[this.ruleSelectIndex].ruleName = arg.ruleName;
    },
    async showDialog(index) {
      this.ruleSelectIndex = index;
      await this.queryReceiveRuleList();
      this.$refs.receiveRuleRef.showDialog(this.receiveRuleAllList);
    },
    isSelect(row) {
      return row.receivedSiteRsp == null ? 1 : 0;
    },
    // 记录当前选择项
    handleSwitchchange(item) {
      this.switchSelected.ruleCode = item.ruleCode;
      this.switchSelected.status = item.status ? true : false;
    },
    async queryRuleRmexcess() {
      let res = await axios.post(api.queryCoalCompanySiteRuleList);
      if (res.data.rules.length > 0) {
        this.siteRuleParams = res.data.rules;
        this.grossWeightLimitStatus = res.data.grossWeightLimit;
      }
    },
    // 过滤当前已添加的收单规则，置为disabled
    // handelFormReceiveRule(item) {
    //   for (let i = 0; i < this.receiveRuleAllList.length; i++) {
    //     let list = this.receiveRuleAllList[i];
    //     for (let j = 0; j < item.length; j++) {
    //       let subItem = item[j];
    //       if (list.ruleCode === subItem.ruleCode) {
    //         this.receiveRuleAllList[i].disabled = true;
    //         subItem.constParams = list.constParams;
    //         subItem.ruleName = list.ruleName;
    //         break;
    //       } else {
    //         this.receiveRuleAllList[i].disabled = false;
    //       }
    //     }
    //   }
    //   console.log("哈哈哈哈");
    //   console.log(item);
    // },
    fetchData() {
      axios
        .post(api.querySignReceiveSiteDetail, { signSiteCode: this.siteCode })
        .then((res) => {
          this.formRecopient = res.data.receivePeopleList || [];
          if (this.formRecopient.length == 0) {
            this.formRecopient = [
              // 待添加收单员list
              {
                name: "",
                phone: "",
                onState: 0,
              },
            ];
          }
          this.formReceiveRule = res.data.coalReceiveRuleList || [];
          if (this.formReceiveRule.length == 0) {
            this.formReceiveRule = [
              {
                ruleCode: "",
                constParams: null,
                ruleName: "",
              },
            ];
          } else {
            this.formReceiveRule.forEach((el) => {});
          }
          this.siteName = res.data.signSiteName;
          this.siteAddress = res.data.siteAddressDetail;
          this.relAddressName = res.data.relAddressName;
          this.latitude = res.data.latitude;
          this.longitude = res.data.longitude;
          this.effectiveTonError =
            res.data.effectiveTonError === -1 ? "" : res.data.effectiveTonError;
          this.grossWeightLimit = res.data.grossWeightLimit
            ? res.data.grossWeightLimit
            : "";
          this.grossWeightLimitStatus = res.data.grossWeight;
          this.siteRuleParams = res.data.ruleList;
          this.siteRuleParams.map((item) => {
            if (item.status) {
              this.switchSelected.ruleCode = item.ruleCode;
              this.switchSelected.status = item.status;
            }
          });
        });
    },
    // 根据当前添加的收单员与查出来的收单员进行匹配，如果收单员姓名和手机号都匹配，则选中此项
    handelMultipleTableSelected() {
      let formRecopientLen = this.formRecopient.length;
      if (formRecopientLen > 0) {
        for (let i = 0; i < formRecopientLen; i++) {
          for (let j = 0; j < this.addressList.length; j++) {
            if (
              this.addressList[j].contactsName === this.formRecopient[i].name &&
              this.addressList[j].contactsTel === this.formRecopient[i].phone
            ) {
              this.$refs.multipleTable.toggleRowSelection(this.addressList[j], true);
              break;
            }
          }
        }
      }
    },
    // 查询所有收单规则列表
    async queryReceiveRuleList() {
      let res = await axios.post(api.receiveRuleList);
      this.receiveRuleAllList = res.data.rules || [];
      // 因为切换tab后receiveRuleAllList重新查了一遍，所以还得过滤一遍
      // this.handelFormReceiveRule(this.formReceiveRule);
    },
    // 查询企业常用地址
    async selectAddressDropdown() {
      let res = await axios.post(api.getAddressList, { pageNum: 1, pageSize: 500 });
      this.addressList = res.data.data || [];
    },
    // 触发选择收单员弹层
    async handleIconClick() {
      await this.selectAddressDropdown();
      this.multipleSelection = [];
      this.$nextTick(() => {
        this.handelMultipleTableSelected();
      });
      this.dialogRecopientVisible = true;
    },
    // 节点名称 选择常用地址
    async handleSearchAddress() {
      await this.selectAddressDropdown();
      this.dialogSiteSelectVisible = true;
    },
    // 节点 选择常用地址确认
    handleUseAddress(item) {
      this.siteAddress = item.addressDetail;
      this.latitude = item.latitude;
      this.longitude = item.longitude;
      this.relAddressName = item.addressName;
      if (this.siteName === "") this.siteName = item.addressName;
      this.dialogSiteSelectVisible = false;
    },
    handleClearAddress(e) {
      this.siteAddress = "";
      this.latitude = 0;
      this.longitude = 0;
      e.stopPropagation();
    },
    mouseEnter() {
      if (this.siteAddress != "") {
        this.inputIcon = "close";
      }
    },
    mouseLeave() {
      this.inputIcon = "";
    },
    // 新增收单员
    addRecopient() {
      this.formRecopient.push({ name: "", phone: "", onState: 0 });
    },
    // 新增收单规则
    addReceiveRule() {
      this.formReceiveRule.push({ ruleCode: "", constParams: null, ruleName: "" });
    },
    /**
     * @Description 删除当前节点下待添加的收单员or收单规则
     * @param {string} nowData formReceiveRule:收单员，formReceiveRule:收单规则
     * @param {number} _index 当前索引
     */
    del(nowData, _index) {
      if (nowData === "formReceiveRule") {
        // 收单规则 删除了一项 需对receiveRuleAllList匹配当前项重置disabled
        for (let i = 0; i < this.receiveRuleAllList.length; i++) {
          if (this.receiveRuleAllList[i].ruleCode === this[nowData][_index].ruleCode) {
            this.receiveRuleAllList[i].disabled = false;
            break;
          }
        }
      } else {
        // 收单员 删除了一项 需要取消表格当前行选中状态
        for (let i = 0; i < this.addressList.length; i++) {
          if (this.addressList[i].contactsName === this[nowData][_index].name) {
            this.$refs.multipleTable.toggleRowSelection(this.addressList[i]);
            break;
          }
        }
      }
      this[nowData].splice(_index, 1);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择收单员确认
    confirm() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请至少选择一个收单员");
        return;
      }
      let selectArray = this.multipleSelection.map((el) => {
        return {
          name: el.contactsName,
          phone: el.contactsTel,
          onState: 0,
          source: "select",
        };
      });
      this.dialogRecopientVisible = false;
      const res = new Map();
      var concatList =
        this.formRecopient.length == 1 &&
        this.formRecopient[0].name == "" &&
        this.formRecopient[0].phone == ""
          ? []
          : this.formRecopient;
      this.formRecopient = [
        ...concatList.filter((el) => !el.hasOwnProperty("source")),
        ...selectArray,
      ].filter((item) => !res.has(item.phone) && res.set(item.phone, 1));
    },
    // 选择收单员取消
    cancel() {
      this.dialogRecopientVisible = false;
      if (this.multipleSelection.length > 0) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 添加最终数据保存
    async saveAll() {
      let result = this.valid();
      if (!result) return;
      let rules = this.siteRuleParams.map((item) => {
        return {
          id: item.id,
          ruleCode: item.ruleCode,
          ruleName: item.ruleName,
          status: item.status,
        };
      });

      let postData = {
        siteCode: this.siteCode,
        version: this.siteCode ? 1 : null,
        siteName: this.siteName.replace(/\s*/g, ""),
        siteAddress: this.siteAddress,
        latitude: this.latitude,
        longitude: this.longitude,
        rules: rules,
        effectiveTonError: this.effectiveTonError ? +this.effectiveTonError : -1,
        grossWeightLimit: this.grossWeightLimitStatus ? this.grossWeightLimit : "",
        recipientInfos: this.formRecopientSubmit,
        lineRules: this.formReceiveRuleSubmit,
        relAddressName: this.siteAddress ? this.relAddressName : "",
      };
      /**
       * @Description 添加签收点
       * @param {string} siteName 节点名称
       * @param {string} siteAddress 站点地址
       * @param {string} recipientInfos  收单人列表，创建时传递格式：姓名@电话，姓名@电话
       * @param {string} lineRules  收单规则列表，创建时传递格式：ruleCode,ruleCode
       */
      await axios.post(api.addOrUpdateSignSite, postData);
      this.$message.success("添加成功");
      this.$router.push({ path: "/companyRecipientManange" });
    },
    // 保存验证
    valid() {
      // 每次保存前需重置最终提交收单员和收单规则list
      this.formRecopientSubmit = [];
      this.formReceiveRuleSubmit = [];
      let phoneList = []; // 手机号存储数组
      let validStatus = true;
      if (!this.siteName) {
        validStatus = false;
        this.$message.error("节点名称不能为空");
        return;
      }
      if (
        this.effectiveTonError &&
        (!isNumber(this.effectiveTonError, true, 4) ||
          !isRangeNumber(this.effectiveTonError, 0, 100000, true, false))
      ) {
        validStatus = false;
        this.$message.error("签收差值不能超过99999，请重新设置");
        return;
      }

      if (
        this.grossWeightLimitStatus &&
        this.grossWeightLimit &&
        (!isNumber(this.grossWeightLimit, false, 2) ||
          !isRangeNumber(this.grossWeightLimit, 0, 10000, false, false))
      ) {
        validStatus = false;
        this.$message.error("签收毛重格式不正确，请重新设置");
        return;
      }
      try {
        this.formRecopient.forEach((el) => {
          for (let key in el) {
            if (el[key] === null || el[key] === "") {
              validStatus = false;
              throw new Error("请完善收单员信息后重试");
            }
            if (key === "phone" && !isPhone(el[key])) {
              validStatus = false;
              throw new Error("手机号格式不正确");
            }
          }
          if (!validStatus) return;
          phoneList.push(el.phone);
          this.formRecopientSubmit.push({
            name: el.name,
            phone: el.phone,
            onState: el.onState ? 1 : 0,
          });
        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      if (isRepeat(phoneList)) {
        validStatus = false;
        this.$message.error("手机号不能重复");
        return;
      }
      if (this.siteCode) {
        if (this.formReceiveRule.length === 0) {
          validStatus = false;
          this.$message.error("请完善收单规则信息后重试");
          return;
        }
        for (let i = 0; i < this.formReceiveRule.length; i++) {
          let item = this.formReceiveRule[i];
          if (!item.ruleCode) {
            validStatus = false;
            this.$message.error("请完善收单规则信息后重试");
            return;
          }
          if (!validStatus) return;
          this.formReceiveRuleSubmit[i] = item.ruleCode;
        }
      } else {
        this.formReceiveRule.forEach((el, idx) => {
          for (let key in el) {
            if (key !== "constParams" && (el[key] === null || el[key] === "")) {
              validStatus = false;
              this.$message.error("请完善收单规则信息后重试");
              return;
            }
          }
          if (!validStatus) return;
          this.formReceiveRuleSubmit[idx] = el.ruleCode;
        });
      }

      return validStatus;
    },
    saveOff() {
      this.$router.push({ path: "/companyRecipientManange" });
    },
  },
  filters: {
    filterConstParams(constParams) {
      let str = "";
      if (!constParams) return str;
      constParams.forEach((val) => {
        if (val.inputType !== 2) {
          // inputType:1表示文本框，2表示下拉框
          let valNow = val.value;
          if (val.valueType === 2) {
            valNow = val.value;
          }
          str += val.name + ":" + valNow + val.valueUnit + ";";
        } else {
          if (val.valueData) {
            let parseIntVal = parseInt(val.value);
            for (let key in val.valueData) {
              if (val.valueData[key] == parseIntVal) {
                str += val.name + ":" + key + ";";
              }
            }
          }
        }
      });
      return str;
    },
  },
};
// 判断手机号是否重复
function isRepeat(arr) {
  let hash = {};
  for (let i in arr) {
    if (hash[arr[i]]) return true;
    hash[arr[i]] = true;
  }
  return false;
}
</script>
<style lang="postcss">
.recipient-add-wrap {
  .suffix-style {
    width: 32px;
    height: 32px;
  }
  .recipient-add-del {
    width: 56px;
    height: 30px;
    border-radius: 4px;
    background-color: rgba(255, 244, 242, 1);
    color: rgba(243, 88, 86, 1);
    border-radius: 4px;
    border: 0px;
  }
  .phone-right-style {
    display: inline-block;
    margin-top: 5px;
  }
  .receiver-rule-style {
    display: flex;
    flex-direction: column;
  }
  .dec {
    max-width: 635px;
    font-size: 14px;
    color: rgba(170, 170, 170, 1);
  }
  .recipient-add-con {
    background: #f6f7fbff;
    padding: 15px;
  }
  .recipient-add-button-style {
    width: 80px;
    height: 28px;
    background-color: #f2fff6ff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 140px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .recipient-add-button-style img {
    width: 16px;
    height: 16px;
  }
  .recipient-add-button-style span {
    font-size: 14px;
    color: #01d28eff;
    margin-left: 3px;
  }
  .recipient-card-style {
    padding: 12px 12px 0 12px;
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 8px;
  }
  .recipient-add-wrap .label-custom {
    display: inline-block;
    width: 105px;
    text-align: right;
  }
  .recipient-add-wrap .iconfont-ticket {
    width: 24px;
    color: #11ab19;
    cursor: pointer;
  }
  .recipient-add-wrap .input-custom {
    margin: 0 0 0 10px;
    width: 200px;
  }
  .recipient-add-wrap .input-custom-short {
    margin: 0 0 0 10px;
    width: 120px;
  }

  .recipient-add-wrap .el-form-item {
    margin-bottom: 10px !important;
  }
  .recipient-add-wrap .recipient-add-search,
  .recipient-add-wrap {
    width: 56px;
    height: 30px;
    margin-top: 3px;
  }
  .state-tip-icon {
    font-size: 24px;
    vertical-align: middle;
  }
  .recipient-bottom-button {
    width: 128px;
    height: 44px;
  }
  .recipient-bottom-button-back {
    border: 1px solid rgba(1, 210, 142, 1);
    border-radius: 4px;
    color: rgba(1, 210, 142, 1);
  }
}
</style>
